import React, { memo, useRef } from 'react';
import { M31ProductCarouselModule as M31ProductCarouselProps } from '~/lib/data-contract';
import ProductCarousel from './components/product-carousel/product-carousel.component';
import ProductCarouselSkeleton from './components/product-carousel-skeleton/product-carousel-skeleton.component';
import { config } from './constants';
import { useInView } from '~/shared/hooks/useInView/useInView';
import { useFrequentlyBoughtTogether } from './hooks';
import { Container } from '../container/container.component';

const M31ProductCarousel = memo(
    ({
        method: model = 'related-products',
        maxNumberItems,
        threshold = 0,
        ...rest
    }: M31ProductCarouselProps) => {
        const ref = useRef(null);
        const isInView = useInView(ref, config.intersectionObserverOptions);
        const { hits, isLoading } = useFrequentlyBoughtTogether(
            {
                model,
                maxRecommendations: maxNumberItems ?? config.maxNumberItemsDefault,
                ...(threshold && { threshold }),
            },
            isInView
        );

        return (
            <div ref={ref}>
                <Container fullWidth {...rest}>
                    {isInView ? (
                        <ProductCarousel hits={hits} isLoading={isLoading} />
                    ) : (
                        <ProductCarouselSkeleton />
                    )}
                </Container>
            </div>
        );
    }
);

export default M31ProductCarousel;
